import React, { Component } from 'react'
import userManager from './userManager'
import Splash from 'App/Splash'

class Logout extends Component {
  componentDidMount () {
    userManager.signoutRedirect()
    userManager.removeUser()
  }

  render () {
    return <Splash text='Carregando...' />
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/Auth/Logout.js